import { absolutePath } from "./absolutePath";

export const workflowsUpcomingEvents = {
  index: (params: Record<string, unknown>) =>
    absolutePath("events/upcoming_events", params),
  show: (id: string | number, params: Record<string, unknown>) =>
    absolutePath(`events/upcoming_events/${id}`, params),
};
